import { TaskDashboard } from "@/components/TaskDashboard";
import Dashboard from "@/pages/admin/Dashboard";

export default function AdminHome() {
  return (
    <div>
      <TaskDashboard />
      <Dashboard />
    </div>
  );
}
